import { render, staticRenderFns } from "./BackTecSup.vue?vue&type=template&id=17bc2526&scoped=true"
import script from "./BackTecSup.vue?vue&type=script&lang=js"
export * from "./BackTecSup.vue?vue&type=script&lang=js"
import style0 from "./BackTecSup.vue?vue&type=style&index=0&id=17bc2526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc2526",
  null
  
)

export default component.exports